module.exports = __webpack_public_path__ + "img/10551384_L.79911fd5.png";